/*eslint-disable */
const $ = window.jQuery = require('jquery');

import VueDatetimeJs from 'vue-datetime-js';
import moment from 'moment';
import toast from '@/services/toast';

export default {
  name: 'employee-leave-portal',
  components: {
      datePicker: VueDatetimeJs,
  },
  props: [],
  data () {
    return {
      submitted:false,
      reason:'',
      start_date:'',
      end_date:'',
      one_day:'',
      single_day_leave:false,
      multiple_day_leave:true,
      leave_type:'',
      select_type:'Multiple',
      is_half_day:false,
      minDatetime:new Date().toISOString(),
      datetimeConfig: ['Sunday'],
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    selectedOptionMethod(val){
      if(val == 'Single'){
        this.submitted = false
        this.multiple_day_leave = false
        this.is_half_day = false
        this.single_day_leave = true
        this.$validator.reset()
      }else{
        this.submitted = false
        this.is_half_day = false
        this.single_day_leave = false
        this.multiple_day_leave = true
        this.$validator.reset()
      }
    },
    validateMultipleDaysBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              reason:this.reason,
              leave_type:this.leave_type,
              single_day_leave:this.single_day_leave,
              multiple_day_leave:this.multiple_day_leave,
              is_half_day:this.is_half_day,
              start_date:moment(this.start_date).format('YYYY-MM-DD HH:mm'),
              end_date:moment(this.end_date).format('YYYY-MM-DD HH:mm')
            }
            this.$store.dispatch('employeeRequestForLeaveFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);           
                  this.submitted = false;
                  this.$router.push({ name: 'LeaveList'})
              }).catch((err) => {        
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    },
    validateSingleDayBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              reason:this.reason,
              leave_type:this.leave_type,
              single_day_leave:this.single_day_leave,
              multiple_day_leave:this.multiple_day_leave,
              is_half_day:this.is_half_day,
              on_date:moment(this.one_day).format('YYYY-MM-DD HH:mm'),
              start_date:moment(this.one_day).format('YYYY-MM-DD HH:mm'),
              end_date:moment(this.one_day).format('YYYY-MM-DD HH:mm')
            }
            this.$store.dispatch('employeeRequestForLeaveFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);           
                  this.submitted = false;
                  this.$router.push({ name: 'LeaveList'})
              }).catch((err) => {       
                toast.error(err.data.user_msg || err.data.msg);
                if(this.one_day != ''){
                  this.submitted = false;
                }
              })
            return;
        }
      });
    },
  }
}